import OnDemandDevelopers from "../on-demand-developers";
import ProjectByEquity from "../project-by-equity";
import FullProjectDevelopment from "../full-project-development";
import WhatServices from "../what-services";
import Confirmation from "../confirmation";
import NavBar from "../nav-bar";
// import Intro from "../Intro";
// import OurServices from "../our-services";
// import SeeOurWork from "../see-our-work";
// import ImpactAcrossIndustries from "../impact-across-industries";
// import WhatMakeUsDifferent from "../what-make-us-different";
// import WhatOurClientSays from "../what-our-client-says";
// import MeetOurTeam from "../meet-our-team";
// import AboutUs from "../about-us";
import Grid from "@mui/material/Grid/Grid";
// import {
//     CustomLabelLargeBold,
//     CustomLabelLargeBoldRedHat, CustomLabelLargeServiceDetailsBold,
//     CustomLabelMediumBold,
//     CustomLabelMediumRegular, CustomLabelMediumRegularDetailsInto,
//     CustomLabelMediumRegularInto,
//     CustomLabelMediumRegularRedHatInto,
//     CustomLabelMediumSmallBold,
//     CustomLabelRegularLargeMedium,
//     CustomLabelRegularMedium,
//     CustomLabelSmallBold,
//     CustomLabelSmallMediumRegular,
//     CustomLabelSmallRegular,
//     CustomLabelXSmallRegular
// } from "../common/CustomLabel";
// import Box from "@mui/material/Box/Box";
// import IPHONE151 from "../../assets/images/iPhone 15 Pro-1.png";
// import ContactUs from "../contact-us";
import Footer from "../footer";
import React, {useRef, useState} from "react";
// import {useMediaQuery} from "@mui/material";
// import createTheme from "@mui/material/styles/createTheme";
// import IntroDetails from "../intro-details";
import WorkDetails from "../work-details";
// import PROJECT1 from "../../assets/images/project_1.png";
// import PROJECT2 from "../../assets/images/project2.png";
// import PROJECT3 from "../../assets/images/project3.png";

// import PROJECT_DETAILS from "../../assets/images/project-details.png";
// import ListItem from "@mui/material/ListItem/ListItem";
// import ListItemText from "@mui/material/ListItemText/ListItemText";
// import List from "@mui/material/List/List";
// import {motion, AnimatePresence} from 'framer-motion';
import { useParams } from "react-router-dom";
import Blog1 from "./blog1";
import Blog2 from "./blog2";
import Blog3 from "./blog3";
// import BLOG_IMAGE from "../../assets/images/blog.png";
import Blog4 from "./blog4";
import Blog5 from "./blog5";
import Blog6 from "./blog6";
import Blog7 from "./blog7";
import Blog8 from "./blog8";
import Blog9 from "./blog9";
import Blog10 from "./blog10";
import Blog11 from "./blog11";
import Blog12 from "./blog12";
import Blog13 from "./blog13";
import Blog14 from "./blog14";
import Blog15 from "./blog15";
import Blog16 from "./blog16";
import Blog17 from "./blog17";
import Blog18 from "./blog18";

import BLOG1HERO from "../../assets/blogs/Blog 1 - hero image.webp";
import BLOG2HERO from "../../assets/blogs/blog 2 hero image.webp";
import BLOG3HERO from "../../assets/blogs/blog 3-hero image x-Creative Web App Ideas for Entrepreneurs.webp";
import BLOG4HERO from "../../assets/blogs/blog 4 image 4.webp";
import BLOG5HERO from "../../assets/blogs/Blog 5 hero image.webp";
import BLOG6HERO from "../../assets/blogs/Blog 6 - hero image.webp";
import BLOG7HERO from "../../assets/blogs/Blog 7 - hero image.webp";
import BLOG8HERO from "../../assets/blogs/Blog 8 - hero image.webp";
import BLOG9HERO from "../../assets/blogs/Blog 9 - inside image.webp";
import BLOG10HERO from "../../assets/blogs/Blog 10 - inside image (10).webp";
import BLOG11HERO from "../../assets/blogs/Blog 11 - inside image.webp";
import BLOG12HERO from "../../assets/blogs/blog 12 hero image.webp";
import BLOG13HERO from "../../assets/blogs/Blog 13 hero image.webp";
import BLOG14HERO from "../../assets/blogs/blog 14 Hero image.webp";
import BLOG15HERO from "../../assets/blogs/Blog 15 hero image.webp";
import BLOG16HERO from "../../assets/blogs/Blog 16 - inside image (9).webp";
import BLOG17HERO from "../../assets/blogs/Blog 17 hero image.webp";
import BLOG18HERO from "../../assets/blogs/Blog 18 Hero image (1).webp";

// const theme = createTheme({
//     breakpoints: {
//         values: {
//             xs: 0,
//             sm: 710,
//             md: 950,
//             lg: 1300,
//             xl: 1350,
//         },
//     },
// });


// Carousel settings for react-slick
// var settings_our_work = {
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     initialSlide: 0,
//     adaptiveHeight: true,
//     responsive: [

//         {
//             breakpoint: 1300, // Large screens
//             settings: {
//                 slidesToShow: 2.5,
//             },
//         },

//         {
//             breakpoint: 1200, // Large screens
//             settings: {
//                 slidesToShow: 2.5,
//             },
//         },
//         {
//             breakpoint: 1024, // Large screens
//             settings: {
//                 slidesToShow: 2,
//             },
//         },
//         {
//             breakpoint: 700, // Large screens
//             settings: {
//                 slidesToShow: 1.5,
//             },
//         },
//         {
//             breakpoint: 480, // Mobile
//             settings: {
//                 slidesToShow: 1.2,
//             },
//         },
//     ],
// };


// Carousel settings for react-slick
// var settings = {
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     initialSlide: 0,
//     adaptiveHeight: true,
//     responsive: [
//         {
//             breakpoint: 1024, // Large screens
//             settings: {
//                 slidesToShow: 2,
//             },
//         },
//         {
//             breakpoint: 480, // Mobile
//             settings: {
//                 slidesToShow: 1.2,
//             },
//         },
//     ],
// };


// Carousel settings for react-slick
// var profile_carousel_settings = {
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     initialSlide: 0,
//     adaptiveHeight: true,
//     responsive: [
//         {
//             breakpoint: 1400, // Large screens
//             settings: {
//                 slidesToShow: 3.5,
//             },
//         },
//         {
//             breakpoint: 1200, // Large screens
//             settings: {
//                 slidesToShow: 2.5,
//             },
//         },
//         {
//             breakpoint: 1024, // Large screens
//             settings: {
//                 slidesToShow: 2.5,
//             },
//         },
//         {
//             breakpoint: 680, // Mobile
//             settings: {
//                 slidesToShow: 1.5,
//             },
//         },
//     ],
// };


const BlogDetails = () => {
    const { blogId } = useParams();

    const [isMenuClicked, setIsMenuClicked] = useState(false)

    // const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const [showFullProject, setShowFullProject] = useState(false);
    const [showOnDemandDevelopers, setShowOnDemandDevelopers] = useState(false);
    const [showProjectByEquity, setShowProjectByEquity] = useState(false);
    const [showWhatServices, setShowWhatService] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);


    const serviceRef = useRef(null);
    const portfolioRef = useRef(null);
    const testimonalsRef = useRef(null);
    const partnersRef = useRef(null);
    const contactUsRef = useRef(null);
    let Details = {};
    if(blogId === "app-development-for-startups-strategies-2025"){
        Details = {
            img: BLOG1HERO,
            date:"April 9, 2025",
            title: "App Development for Startups - Important Strategies for 2025",
            description:"Technology is growing fast, and so is the need for App Development. Any new business finds it harder to establish a strong presence without developing a mobile application in today's market. A mobile app that is properly designed offers your business a powerful advantage for industry disruption or introducing new major innovations.",
            tags: ["UI/UX Design", "Front-end Development", "Website"]
            };
    }
    if(blogId === "key-factors-choosing-app-development-company-usa"){
        Details = {
            img: BLOG2HERO,
            date:"April 9, 2025",
            title: "Key Factors to Consider When Choosing an App Development Company in the USA",
            description:"Mobile phones are no longer a luxury; they're the backbone of how people connect, shop, work, and live today. We have moved beyond the days when mobile apps were exclusive to tech giants such as Amazon, Walmart, and Target. Now, even small businesses and ambitious startups across the U.S. are investing in Custom App Development to stay competitive and reach their audiences where it matters most on their smartphones.",
            tags: ["UI/UX Design", "Front-end Development", "Website"]
        };
    }
    if(blogId === "creative-web-app-ideas-for-entrepreneurs"){
        Details = {
            img: BLOG3HERO,
            date:"April 14, 2025",
            title: "Creative Web App Ideas for Entrepreneurs",
            description:"As the world becomes increasingly digital, entrepreneurs are continuously looking for innovative ways to engage customers and streamline business processes. Web application development stands as an indispensable business tool that companies regularly use in their strategic planning. Through their ability to enhance service delivery, businesses achieve better operations while developing new revenue potential. Web Application Development Companies can achieve new success by implementing excellent web application ideas to meet both starting businesses and expanding companies.",
            tags: ["UI/UX Design", "Front-end Development", "Website"]
        };
    }
    if(blogId === "how-generative-ai-is-changing-software-development-2025"){
        Details = {
            img: BLOG4HERO,
            date:"April 15, 2025",
            title: "How Generative AI is Changing Software Development in 2025",
            description:"Generative AI changes the essential foundation of software development to the point where it transforms its complete life cycle from design through testing and maintenance in 2025. The creation of code through AI capabilities was previously seen as science fiction but has since brought a practical and developing element to standard development operations. The development of large language models (LLMs) in tools such as OpenAI Codex, GitHub Copilot, along with other platforms, formed vital systems that enhance productivity while improving code quality and enabling teams to dedicate efforts toward solving real problems instead of writing unnecessary code.",
            tags: ["UI/UX Design", "Front-end Development", "Website"]
        };
    }
    if(blogId === "mobile-app-development-cost-usa"){
        Details = {
            img: BLOG5HERO,
            date:"April 21, 2025",
            title: "Expert Guide on Mobile App Development Cost in USA",
            description:"In 2025, mobile apps aren’t just part of the plan – they are the plan. They’ve become the front door to almost every business, from bold startups to household names. With nearly 7 billion smartphones in hand worldwide, ignoring mobile phones is like closing a shop during rush hour. Whether you’re running a digital storefront or offering local services, people expect you to show up on their screens - fast, smooth, and at their fingertips. So it’s no surprise that one of the biggest questions business owners ask is ‘What’s it going to cost me to build an app?’ If you’re in Florida or eyeing it as your tech hub, this guide unpacks what goes into Mobile App Development Costs - from the features that add dollars to the hidden decisions that help you save. We’ll talk about industry trends, regional pricing insights, and mindful ways to build smart Mobile Applications without burning through your budget.",
            tags: [""]
        };
    }
    if(blogId === "best-mobile-banking-apps-in-usa"){
        Details = {
            img: BLOG6HERO,
            date:"April 22, 2025",
            title: "Top 10 Mobile Banking Apps in the USA",
            description:"In today’s digital-first world, managing money on the go isn’t just convenient - it’s expected. Whether you're transferring funds, paying bills, tracking expenses, or receiving real-time transaction alerts, the right mobile banking app can redefine your relationship with money. But with so many apps crowding the market, how do you pick the best?",
            tags: [""]
        };
    }
    if(blogId === "10-must-have-features-successful-mobile-app-usa"){
        Details = {
            img: BLOG7HERO,
            date:"April 26, 2025",
            title: "10 Must-Have Features in a Successful Mobile App in the USA",
            description:"In today’s mobile-first world, an app isn’t just a nice-to-have - it’s often the primary way people engage with businesses and services. Whether you're building a fitness tracker, an e-commerce platform, or a budgeting app, one thing remains true - users expect more than just basic functionality",
            tags: [""]
        };
    }
    if(blogId === "best-mobile-app-development-tools"){
        Details = {
            img: BLOG8HERO,
            date:"April 28, 2025",
            title: "Best Mobile App Development Tools - Features, Pros, and Cons",
            description:"Building a mobile app starts with a crucial decision: choosing the right tech stack. Think of it like assembling a toolkit for a masterpiece. Even the most brilliant app idea can falter without the proper tools behind it. ",
            tags: [""]
        };
    }
    if(blogId === "php-vs-javascript-best-tech-stack-scalable-web-app"){
        Details = {
            img: BLOG9HERO,
            date:"April 30, 2025",
            title: "PHP vs JavaScript - Choosing the Best Tech Stack for Scalable Web App Development",
            description:"Knowledge about programming language differences represents an absolute requirement for achieving app and web development success. For iOS and Android app development companies at the top of their performance, execute projects depends heavily on selecting the proper technology stack.",
            tags: [""]
        };
    }
    if(blogId === "dating-apps-in-usa"){
        Details = {
            img: BLOG10HERO,
            date:"May 05, 2025",
            title: "Top 10 Dating Apps in USA – 2025 ",
            description:"Online dating isn’t just a trend anymore—it’s how millions of Americans meet their partners. Around 381 million people were using dating apps globally in 2023, and that number is expected to grow to 452 million by 2028. Swiping right is now a normal part of how Americans meet and ...",
            tags: [""]
        };
    }
    if(blogId === "top-fitness-app-ideas-usa"){
        Details = {
            img: BLOG11HERO,
            date:"May 08, 2025",
            title: "10 Top Fitness App Ideas to Launch in the USA in 2025",
            description:"In a world where fitness is more than just a solo grind and motivation grows through community, social fitness apps are changing how we move, sweat, and stay accountable. Gone are the days when your workout buddy had to live next door. Now, with a good app, your fitness crew ...",
            tags: [""]
        };
    }
    if(blogId === "food-delivery-app-ideas"){
        Details = {
            img: BLOG12HERO,
            date:"May 12, 2025",
            title: "15 Food Delivery App Ideas to Start in 2025",
            description:"Thinking about starting a food business from home or looking for new food delivery startup ideas? Mobile apps are a great place to begin. The demand for quick, easy, and safe food delivery is only growing, and there are many different types of food services people are looking for ...",
            tags: [""]
        };
    }
    if(blogId === "innovative-mental-health-apps-growth-wellbeing"){
        Details = {
            img: BLOG13HERO,
            date:"May 15, 2025",
            title: "Top 10 Most-Innovative Mental Health App Ideas for Growth and Well-Being - 2025",
            description:"The future of mental wellness is digital - and deeply personal. In 2025, the global mental health app market surpassed $8.5 billion, and it's forecasted to exceed $36 billion by 2034. This unprecedented growth isn't just about technology - it's about meeting the rising demand for ...",
            tags: [""]
        };
    }
    if(blogId === "top-mvp-development-companies-usa"){
        Details = {
            img: BLOG14HERO,
            date:"May 20, 2025",
            title: "10 Top-Rated MVP Development Companies in USA",
            description:"Have a groundbreaking app idea but not sure where to start? You’re not alone. Many startups begin with just an idea, some sketches, and a limited budget. Instead of going all in with a full-scale product, the smarter route is launching a Minimum Viable Product (MVP) - a lean version ...",
            tags: [""]
        };
    }
    if(blogId === "build-real-estate-app-no-code-guide"){
        Details = {
            img: BLOG15HERO,
            date:"May 22, 2025",
            title: "Build a Real Estate App in 2025 Using No-Code Platforms – Complete Guide",
            description:"You’ve got a compelling idea and the drive to make it real. Now let’s bring your concept to life with an intuitive, no-code development approach. No need for an advanced tech background or hiring costly developers. Just follow the steps below, and you’ll be on your way to a feature-rich ...",
            tags: [""]
        };
    }
    if(blogId === "mobile-app-development-trends-dallas"){
        Details = {
            img: BLOG16HERO,
            date:"May 26, 2025",
            title: "Top 10 Mobile App Development Trends in Dallas – OSTRYX Insights",
            description:"Mobile app development in Dallas is growing fast, with many startups looking for new ways to improve and stand out. As the city becomes more active in tech and business, mobile apps have gone from being helpful tools to important parts of how companies compete.New technologies like ...",
            tags: [""]
        };
    }
    if(blogId === "real-estate-app-development-timeline"){
        Details = {
            img: BLOG17HERO,
            date:"May 29, 2025",
            title: "How Long Will It Take to Develop Your Real Estate App? Here's What to Expect From Start to Finish",
            description:"Ever wondered how long it would take to build your real estate app that can compete with big platforms like Zillow or Bayut? It’s a common question — and one that matters a lot. The timeline depends on your goals, how you plan to get there, and which development team you choose to ...",
            tags: [""]
        };
    }
    if(blogId === "how-to-develop-online-payment-app-usa"){
        Details = {
            img: BLOG18HERO,
            date:"June 05, 2025",
            title: "How to Develop an Online Payment App in USA – OSTRYX Insights",
            description:"Thinking about investing in a payment app? Curious to know how to build an Online Payment App from scratch? You're at the right place. With mobile payments becoming the go-to method for everything - from ordering food to paying bills - it’s no surprise that more businesses ...",
            tags: [""]
        };
    }
    // const WorkList = {
    //     work: [
    //         {
    //             img: PROJECT1,
    //             title: "EcoVibes Marketplace",
    //             description: "An e-commerce platform promoting sustainable products and eco-friendly living. Features include user-friendly navigation, product reviews, and secure payment options.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         },
    //         {
    //             img: PROJECT2,
    //             title: "HealthLink App",
    //             description: "A mobile application connecting users with healthcare professionals for virtual consultations and medical advice. Features include appointment scheduling, symptom checker, and secure messaging.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         },
    //         {
    //             img: PROJECT3,
    //             title: "TechSavvy Education Portal",
    //             description: "An online learning platform offering courses in technology, coding, and digital skills. Features include interactive lessons, progress tracking, and instructor-led webinars.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         },
    //         {
    //             img: PROJECT1,
    //             title: "EcoVibes Marketplace",
    //             description: "An e-commerce platform promoting sustainable products and eco-friendly living. Features include user-friendly navigation, product reviews, and secure payment options.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         },
    //         {
    //             img: PROJECT2,
    //             title: "HealthLink App",
    //             description: "A mobile application connecting users with healthcare professionals for virtual consultations and medical advice. Features include appointment scheduling, symptom checker, and secure messaging.",
    //             tags: ["UI/UX Design", "Front-end Development", "Website"]
    //         }

    //     ]
    // }

    const renderTemplate = () => {
        switch(blogId) {
            case 'app-development-for-startups-strategies-2025':
                return <Blog1 />;
            case 'key-factors-choosing-app-development-company-usa':
                return <Blog2 />;
            case 'creative-web-app-ideas-for-entrepreneurs':
                return <Blog3 />;
            case 'how-generative-ai-is-changing-software-development-2025':
                return <Blog4 />;
            case 'mobile-app-development-cost-usa':
                return <Blog5 />;
            case 'best-mobile-banking-apps-in-usa':
                return <Blog6 />;
            case '10-must-have-features-successful-mobile-app-usa':
                return <Blog7 />;
            case 'best-mobile-app-development-tools':
                return <Blog8 />;
            case 'php-vs-javascript-best-tech-stack-scalable-web-app':
                return <Blog9 />;
            case 'dating-apps-in-usa':
                return <Blog10 />;
            case 'top-fitness-app-ideas-usa':
                return <Blog11 />;
            case 'food-delivery-app-ideas':
                return <Blog12 />;
            case 'innovative-mental-health-apps-growth-wellbeing':
                return <Blog13 />;
            case 'top-mvp-development-companies-usa':
                return <Blog14 />;
            case 'build-real-estate-app-no-code-guide':
                return <Blog15 />;
            case 'mobile-app-development-trends-dallas':
                return <Blog16 />;
            case 'real-estate-app-development-timeline':
                return <Blog17 />;
            case 'how-to-develop-online-payment-app-usa':
                return <Blog18 />;
            default:
                return <> </>;
        }
    };

    return (
        <Grid style={{width: "100vw", height: "100vh", overflowX: "hidden",}}>

            {
                showOnDemandDevelopers && <OnDemandDevelopers setShowOnDemandDevelopers={setShowOnDemandDevelopers}
                                                              setShowConfirmation={setShowConfirmation}
                />
            }

            {
                showProjectByEquity && <ProjectByEquity setShowProjectByEquity={setShowProjectByEquity}
                                                        setShowConfirmation={setShowConfirmation}/>
            }


            {
                showFullProject && <FullProjectDevelopment setShowFullProject={setShowFullProject}
                                                           setShowConfirmation={setShowConfirmation}/>
            }


            {
                showWhatServices &&
                <WhatServices setShowWhatService={setShowWhatService} setShowFullProject={setShowFullProject}
                              setShowProjectByEquity={setShowProjectByEquity}
                              setShowOnDemandDevelopers={setShowOnDemandDevelopers}/>
            }


            {
                showConfirmation && <Confirmation setShowConfirmation={setShowConfirmation}/>
            }

            <Grid container sx={{position: "relative"}}>
                <NavBar isMenuClicked={isMenuClicked} serviceRef={serviceRef} portfolioRef={portfolioRef}
                        testimonalsRef={testimonalsRef} partnersRef={partnersRef} setIsMenuClicked={setIsMenuClicked}
                        contactUsRef={contactUsRef}
                        className={"background-blur"}
                        setShowWhatService={setShowWhatService}/>


                <Grid container sx={{position: "absolute", top: 0, zIndex: 1}}>


                    <WorkDetails type={5} work={Details}/>


                    <Grid container alignItems={"flex-end"} sx={{height: "100%", position: "absolute", top: "100%"}}
                          justifyContent={"center"}>
                            {renderTemplate()}
                        {/* <Grid container direction={"column"} xs={11}>
                            <Grid item sx={{marginTop: "50px"}}>
                                <CustomLabelMediumSmallBold text={"Heading"} color={"#5E17EB"}/>
                            </Grid>
                            <Grid item sx={{marginTop:"5px"}}>
                                <CustomLabelRegularLargeMedium normal={true} color={"#333333"}
                                text={"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Sed ut turpis nec sapien fringilla fermentum nec id libero. Quisque porttitor hendrerit lectus, et condimentum metus sodales vel. Sed laoreet nulla eget magna eleifend, id ultricies lorem vestibulum."}
                                />
                            </Grid>
                            <Grid item container xs={12} sx={{marginTop:"40px"}}>
                                <Box component={"img"} src={BLOG_IMAGE} sx={{width:"100%",maxHeight:"720px",borderRadius:"20px"}}/>
                            </Grid>


                            <Grid item sx={{marginTop: "50px"}}>
                                <CustomLabelMediumSmallBold text={"Heading"} color={"#5E17EB"}/>
                            </Grid>
                            <Grid item sx={{marginTop:"5px"}}>
                                <CustomLabelRegularLargeMedium normal={true} color={"#333333"}
                                                               text={"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Sed ut turpis nec sapien fringilla fermentum nec id libero. Quisque porttitor hendrerit lectus, et condimentum metus sodales vel. Sed laoreet nulla eget magna eleifend, id ultricies lorem vestibulum. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Sed ut turpis nec sapien fringilla fermentum nec id libero. Quisque porttitor hendrerit lectus, et condimentum metus sodales vel. Sed laoreet nulla eget magna eleifend, id ultricies lorem vestibulum."}
                                />
                            </Grid>
                            <Grid item sx={{marginTop:"25px"}}>
                                <CustomLabelRegularLargeMedium normal={true} color={"#333333"}
                                                               text={"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Sed ut turpis nec sapien fringilla fermentum nec id libero. Quisque porttitor hendrerit lectus, et condimentum metus sodales vel. Sed laoreet nulla eget magna eleifend, id ultricies lorem vestibulum."}
                                />
                            </Grid>
                            <Grid item sx={{marginTop:"25px"}}>
                                <CustomLabelRegularLargeMedium normal={true} color={"#333333"}
                                                               text={"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Sed ut turpis nec sapien fringilla fermentum nec id libero. Quisque porttitor hendrerit lectus, et condimentum metus sodales vel. Sed laoreet nulla eget magna eleifend, id ultricies lorem vestibulum. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Sed ut turpis nec sapien fringilla fermentum nec id libero. Quisque porttitor hendrerit lectus, et condimentum metus sodales vel. Sed laoreet nulla eget magna eleifend, id ultricies lorem vestibulum."}
                                />
                            </Grid>

                            <Grid item container xs={12} sx={{marginTop:"40px"}}>
                                <Box component={"img"} src={BLOG_IMAGE} sx={{width:"100%",maxHeight:"720px",borderRadius:"20px"}}/>
                            </Grid>


                            <Grid item sx={{marginTop: "50px"}}>
                                <CustomLabelMediumSmallBold text={"Heading"} color={"#5E17EB"}/>
                            </Grid>
                            <Grid item sx={{marginTop:"5px"}}>
                                <CustomLabelRegularLargeMedium normal={true} color={"#333333"}
                                                               text={"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Sed ut turpis nec sapien fringilla fermentum nec id libero. Quisque porttitor hendrerit lectus, et condimentum metus sodales vel. Sed laoreet nulla eget magna eleifend, id ultricies lorem vestibulum. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Sed ut turpis nec sapien fringilla fermentum nec id libero. Quisque porttitor hendrerit lectus, et condimentum metus sodales vel. Sed laoreet nulla eget magna eleifend, id ultricies lorem vestibulum."}
                                />
                            </Grid>
                            <Grid item sx={{marginTop:"25px"}}>
                                <CustomLabelRegularLargeMedium normal={true} color={"#333333"}
                                                               text={"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Sed ut turpis nec sapien fringilla fermentum nec id libero. Quisque porttitor hendrerit lectus, et condimentum metus sodales vel. Sed laoreet nulla eget magna eleifend, id ultricies lorem vestibulum."}
                                />
                            </Grid>
                            <Grid item sx={{marginTop:"25px"}}>
                                <CustomLabelRegularLargeMedium normal={true} color={"#333333"}
                                                               text={"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Sed ut turpis nec sapien fringilla fermentum nec id libero. Quisque porttitor hendrerit lectus, et condimentum metus sodales vel. Sed laoreet nulla eget magna eleifend, id ultricies lorem vestibulum. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Sed ut turpis nec sapien fringilla fermentum nec id libero. Quisque porttitor hendrerit lectus, et condimentum metus sodales vel. Sed laoreet nulla eget magna eleifend, id ultricies lorem vestibulum."}
                                />
                            </Grid>
                            <Grid item sx={{marginTop: "50px"}}>
                                <CustomLabelMediumSmallBold text={"Heading"} color={"#5E17EB"}/>
                            </Grid>
                            <Grid item sx={{marginTop:"5px"}}>
                                <CustomLabelRegularLargeMedium normal={true} color={"#333333"}
                                                               text={"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Sed ut turpis nec sapien fringilla fermentum nec id libero. Quisque porttitor hendrerit lectus, et condimentum metus sodales vel. Sed laoreet nulla eget magna eleifend, id ultricies lorem vestibulum. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Sed ut turpis nec sapien fringilla fermentum nec id libero. Quisque porttitor hendrerit lectus, et condimentum metus sodales vel. Sed laoreet nulla eget magna eleifend, id ultricies lorem vestibulum."}
                                />
                            </Grid>

                        </Grid> */}


                        {/* <OurServices serviceRef={serviceRef} setShowOnDemandDevelopers={setShowOnDemandDevelopers}
                                     setShowWhatService={setShowWhatService}
                                     setShowProjectByEquity={setShowProjectByEquity}/>


                        <Grid container sx={{paddingBottom: {xs: "30px", md: "50px"}}} justifyContent={"center"}>

                            <Grid item container justifyContent={"center"} sx={{marginTop: {xs: "20px", md: "50px"}}}>
                                <CustomLabelMediumBold text={"Discuss Your Project with #1 Software Development Company USA "} color={"#5E17EB"}/>
                            </Grid>

                            <Grid item container xs={10} style={{marginTop: "5px"}} justifyContent={"center"}>
                                <CustomLabelMediumRegular normal={false}
                                                          text={"Got an Idea? Let’s Build It Together — Contact Us for Expert Development Solutions. "}
                                />
                            </Grid>


                            <Grid item container xs={12}  justifyContent={"space-between"}
                                  sx={{padding: {xs: "0px 10px", md: "0px 40px"}, marginTop: {xs: "20px", lg: "60px"}}}>


                                <Grid item xs={12} lg={4.8}
                                      sx={{maxHeight: "100%", width: "100%", padding: "0px", position: "relative"}}>
                                    <Box component={"img"} src={IPHONE151}
                                         sx={{height: {lg: "100%"}, width: {xs: "100%", lg: "100%", xlg: "auto"}}}/>
                                </Grid>

                                <ContactUs setShowConfirmation={setShowConfirmation}/>


                            </Grid>

                            <div ref={contactUsRef} tabIndex={0}></div>

                        </Grid> */}


                        <Footer/>

                    </Grid>


                </Grid>
            </Grid>

        </Grid>
    )
}

export default BlogDetails;
